import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  FormDataConsumer,
  FileInput,
  FileField,
  Toolbar,
  ListButton,
  SaveButton,
  DateInput,
} from "react-admin";
import { WithdrawPaymentInfonewSelectInput } from "../../UI/Input/SelectInput";
import { onWithdrawPaymentInfoNewCreate } from "../../Service/Validation/WithdrawPaymentInfonewValidation";
import Grid from "@material-ui/core/Grid";

const PageTitle = () => {
  return <span>Create Category</span>;
};

const FormToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton label="Save" redirect="show" submitOnEnter={true} />
    {!props.saving && <ListButton label="Cancel" />}
  </Toolbar>
);
const SanitizedGrid = ({ basePath, ...props }) => {
  return <Grid {...props} />;
};

const AgreementAndPaymentCreate = (props) => {
  console.log(props);
  return (
    <Create title={<PageTitle />} {...props} undoable={false}>
      <SimpleForm toolbar={<FormToolbar />} reValidateMode="onBlur" warnWhenUnsavedChanges validate={onWithdrawPaymentInfoNewCreate} redirect="list">

        <SanitizedGrid container spacing={3} fullWidth>
          <Grid item sm={12} md={4} lg={4}>
          <TextInput source="profile_id" lable="Profile ID" fullWidth  />
          </Grid>
          <Grid item sm={12} md={4} lg={4}>
          <WithdrawPaymentInfonewSelectInput  label="Select Type" fullWidth source="type"/>
          </Grid>
          
        </SanitizedGrid>
      </SimpleForm>
    </Create>
  );
};
export default AgreementAndPaymentCreate;
